<table class="netzbetreiberTable" mat-table [dataSource]="netzbetreiberList" data-qa="netzbetreiber-list-table" matSort>

  <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
  <tr style="cursor: pointer"
      mat-row
      *matRowDef="let even = even; let netzbetreiber; columns: columnsToDisplay"
      role="link"
      tabindex="0"
      (click)="openDetail(netzbetreiber.id)"
      (keydown.enter)="openDetail(netzbetreiber.id)">
  </tr>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="name">Name</th>
    <td mat-cell *matCellDef="let netzbetreiber;"
        data-qa="name">{{ netzbetreiber.name }}
      @if (netzbetreiber.bemerkung && !isUeNB) {
        <mat-icon class="row-icon bemerkung-icon"
                  svgIcon="innogy_picto_speech-bubble_exclamationmark"
                  [matTooltip]="netzbetreiber.bemerkung"
                  aria-hidden="false"
                  aria-label="Bemerkung: {{ netzbetreiber.bemerkung }}"
        ></mat-icon>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="zuweisungDeaktiviert">
    <th mat-header-cell *matHeaderCellDef style="width:7rem">Vorgang zuweisbar</th>
    <td mat-cell *matCellDef="let netzbetreiber;" data-qa="zuweisung-deaktiviert">
      <mat-icon class="row-icon" [svgIcon]="netzbetreiber.zuweisungDeaktiviert ? 'innogy_picto_close' : 'innogy_picto_check'">
      </mat-icon>
    </td>
  </ng-container>


  <ng-container matColumnDef="eicNummer">
    <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="eicNummer">EIC</th>
    <td mat-cell *matCellDef="let netzbetreiber;" data-qa="eicNummer">{{ netzbetreiber.eicNummer }}</td>
  </ng-container>

  <ng-container matColumnDef="eicNummer2">
    <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="eicNummer2">EIC2</th>
    <td mat-cell *matCellDef="let netzbetreiber;" data-qa="eicNummer2">{{ netzbetreiber.eicNummer2 }}</td>
  </ng-container>

  <ng-container matColumnDef="eicNummer3">
    <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="eicNummer3">EIC3</th>
    <td mat-cell *matCellDef="let netzbetreiber;" data-qa="eicNummer3">{{ netzbetreiber.eicNummer3 }}</td>
  </ng-container>


  <ng-container matColumnDef="eicNummerNvnbs">
    <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="eicNummerNvnbs">EIC nnVNB</th>
    <td mat-cell *matCellDef="let netzbetreiber;"
        data-qa="eicNummerNvnbs">{{ netzbetreiber.eicNummerNvnbs?.join(', ') }}
    </td>
  </ng-container>


  <ng-container matColumnDef="stromNetzbetreiberNummer">
    <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="stromNetzbetreiberNummer">Stromnetzbetreibernummer
    </th>
    <td mat-cell *matCellDef="let netzbetreiber;"
        data-qa="stromNetzbetreiberNummer">{{ netzbetreiber.stromNetzbetreiberNummer }}
    </td>
  </ng-container>

  <ng-container matColumnDef="typ">
    <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="typ">Typ</th>
    <td mat-cell *matCellDef="let netzbetreiber;" data-qa="typ">{{ netzbetreiber.typ | orgTypeReadable }}</td>
  </ng-container>

  <ng-container matColumnDef="schaltleitung">
    <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="schaltleitung">Schaltleitung</th>
    <td mat-cell *matCellDef="let netzbetreiber;" data-qa="schaltleitung">
      @if (!!netzbetreiber.schaltleitung) {
        <span>{{ netzbetreiber.schaltleitung }}</span>
      }
      @if (!netzbetreiber.schaltleitung) {
        <span>-</span>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="kundenBetreuer">
    <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="kundenBetreuer">Kundenbetreuer</th>
    <td mat-cell *matCellDef="let netzbetreiber;" data-qa="kundenBetreuer">
      @if (!!netzbetreiber.kundenBetreuer) {
        <span>{{ netzbetreiber.kundenBetreuer }}</span>
      }
      @if (!netzbetreiber.kundenBetreuer) {
        <span>-</span>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="updateDateTime">
    <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="updateDateTime">Letzte Änderung</th>
    <td mat-cell *matCellDef="let netzbetreiber;" data-qa="updateDateTime">
      @if (!!netzbetreiber.updateDateTime) {
        <span>{{ netzbetreiber.updateDateTime | date:'mediumDate':'GMT+1':'de' }}</span>
      }
      @if (!netzbetreiber.updateDateTime) {
        <span>-</span>
      }
    </td>


  </ng-container>

</table>
